import * as qs from 'qs';
import { DisclaimerManagementMapper } from './DisclaimerManagementMapper.js';

function paramsSerializer(params) {
  return qs.stringify(params);
}
class DisclaimerManagementRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  getWeightDeviation(params) {
    return this.apiClient.get('v1/disclaimer-management/weight-deviation', DisclaimerManagementMapper.getWeightDeviationPayload(params), undefined, paramsSerializer).then(response => DisclaimerManagementMapper.createModelFromResponse(response.data));
  }
}

export { DisclaimerManagementRepository };
//# sourceMappingURL=DisclaimerManagementRepository.js.map
